import React from "react";
import "../../Works.css";
import { useEffect } from "react";
import kudoku from "../../img/kudoku.png";
import kosme from "../../img/kosme-new.png";
import relearn from "../../img/relearn-new.png";
import akopangan from "../../img/ako-new.png";
import thomson from "../../img/thomson-new.png";
import amigo from "../../img/amigo-new.png";
import lasagmom from "../../img/lasagmom-new.png";
import yak from "../../img/yak-new.png";

function Works() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <div id="works" className="works-page">
      <section className="works-header px-5 py-10 text-left lg:px-20">
        <h1 className="text-header font-bold mb-3">Works</h1>
        <p className="text-body">
          Life goes on, there’s a probability this project section is not
          updated yet.
        </p>
        <p className="text-body">
          There’s a lot of ambitious project that I’ve been working on, so it’s
          better to chat with me directly 😁
        </p>
      </section>

      <section className="cards flex flex-col px-5 pb-10 justify-start gap-x-10 gap-y-20 lg:px-20 lg:flex-row lg:flex-wrap">
        <section className="card card-kudoku flex flex-col gap-y-6 lg:w-80">
          <img class="works-img w-auto lg:w-80" src={kudoku} alt="kudoku"></img>
          <section className="flex flex-col gap-y-2">
            <h2 className="text-subhead font-bold">Kudoku</h2>
            <section className="card-tags flex gap-x-2">
              <p className="tags">Product development</p>
              <p className="tags">UX</p>
            </section>
            <p className="text-body">
              My second company. Aims to help people manage their finance.
            </p>
          </section>
        </section>

        <section className="card card-kosme flex flex-col gap-y-6 lg:w-80">
          <img class="works-img w-auto lg:w-80" src={kosme} alt="kosme"></img>
          <section className="flex flex-col gap-y-2">
            <h2 className="text-subhead font-bold">Kosme Beauty Lab</h2>
            <section className="card-tags flex gap-x-2">
              <p className="tags">Web dev</p>
              <p className="tags">Vue JS</p>
            </section>
            <p>
              Re-making one of the biggest cosmetics marketplace. Working as
              front-end engineer using Vue.Js.
            </p>
          </section>
        </section>

        <section className="card card-ako flex flex-col gap-y-6 lg:w-80">
          <img
            class="works-img w-auto lg:w-80"
            src={akopangan}
            alt="akopangan"
          ></img>
          <section className="flex flex-col gap-y-2">
            <h2 className="text-subhead font-bold">Akopangan</h2>
            <section className="card-tags flex gap-x-2">
              <p className="tags">UX</p>
              <p className="tags">Web design</p>
              <p className="tags">Web dev</p>
            </section>
            <p>
              Building a website for agriculture company that produces and
              supplies fresh agricultural products to business owners and
              consumers.
            </p>
          </section>
        </section>

        <section className="card card-thomson flex flex-col gap-y-6 lg:w-80">
          <img
            class="works-img w-auto lg:w-80"
            src={thomson}
            alt="thomson"
          ></img>
          <section className="flex flex-col gap-y-2">
            <h2 className="text-subhead font-bold">Thomson</h2>
            <section className="card-tags flex gap-x-2">
              <p className="tags">UX</p>
              <p className="tags">Web design</p>
              <p className="tags">Web dev</p>
            </section>
            <p>
              Making a massive company website for Thomson Radio Network, which
              covers over 50 radio branches with live-streaming and news.
            </p>
          </section>
        </section>

        <section className="card card-relearn flex flex-col gap-y-6 lg:w-80">
          <img
            class="works-img w-auto lg:w-80"
            src={relearn}
            alt="relearn"
          ></img>
          <section className="flex flex-col gap-y-2">
            <h2 className="text-subhead font-bold">Relearn app</h2>
            <section className="card-tags flex gap-x-2">
              <p className="tags">UX</p>
              <p className="tags">Product design</p>
            </section>
            <p>
              Final tasks from Google UX certification. An app to help corporate
              workers studying specific topics on the go.
            </p>
          </section>
        </section>

        <section className="card card-amigo flex flex-col gap-y-6 lg:w-80">
          <img class="works-img w-auto lg:w-80" src={amigo} alt="amigo"></img>
          <section className="flex flex-col gap-y-2">
            <h2 className="text-subhead font-bold">Amigo app</h2>
            <section className="card-tags flex gap-x-2">
              <p className="tags">UX</p>
              <p className="tags">Product design</p>
            </section>
            <p>
              Designing an app for local restaurant called Amigo restaurant. It
              will enables customer to do online order and book a table.
            </p>
          </section>
        </section>

        <section className="card card-lasagmom flex flex-col gap-y-6 lg:w-96">
          <img
            class="works-img w-auto lg:w-80"
            src={lasagmom}
            alt="lasagmom"
          ></img>
          <section className="flex flex-col gap-y-2">
            <h2 className="text-subhead font-bold">Lasagmom</h2>
            <section className="card-tags flex gap-x-2">
              <p className="tags">Product development</p>
              <p className="tags">Web design</p>
              <p className="tags">Web dev</p>
            </section>
            <p>
              My first business. Building an F&B utilizing cloud kitchen
              concept. Managed to propel the business into a $100,000
              angel-round.
            </p>
          </section>
        </section>

        <section className="card card-yak flex flex-col gap-y-6 lg:w-80">
          <img class="works-img w-auto lg:w-80" src={yak} alt="yak"></img>
          <section className="flex flex-col gap-y-2">
            <h2 className="text-subhead font-bold">Yayasan Amaryllis Kirana</h2>
            <section className="card-tags flex gap-x-2">
              <p className="tags">Web design</p>
              <p className="tags">Web dev</p>
            </section>
            <p>
              Pro-bono project. Helping Yayasan Amaryllis Kirana, an NGO
              focusing on helping cancer children to build online presence
              through company website.
            </p>
          </section>
        </section>
      </section>
    </div>
  );
}

export default Works;
